/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ field: NonNullable<unknown> }} Warning_Invalid_OperatorInputs */

const en_warning_invalid_operator = /** @type {(inputs: Warning_Invalid_OperatorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.field} cannot be compared`)
};

const de_warning_invalid_operator = /** @type {(inputs: Warning_Invalid_OperatorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.field} lässt sich nicht vergleichen`)
};

/**
* | output |
* | --- |
* | "{field} cannot be compared" |
*
* @param {Warning_Invalid_OperatorInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const warning_invalid_operator = /** @type {((inputs: Warning_Invalid_OperatorInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Warning_Invalid_OperatorInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_warning_invalid_operator(inputs)
	return en_warning_invalid_operator(inputs)
});